(function () {
  if (!window.matchMedia("(max-width: 767px)").matches) return;

  function bindFix() {
    const host = document.querySelector("pandectes-cmp");
    const root = host && host.shadowRoot;
    if (!root) return false;

    const button = Array.from(root.querySelectorAll("button")).find((el) =>
      /accept|allow|aceitar/i.test((el.textContent || "").trim())
    );

    if (!button || button.dataset.pandectesTouchFixBound === "1") return !!button;

    button.dataset.pandectesTouchFixBound = "1";

    button.addEventListener(
      "touchend",
      function (event) {
        if (document.cookie.indexOf("_pandectes_gdpr=") !== -1) return;
        event.preventDefault();
        event.stopPropagation();
        button.click();
      },
      { passive: false }
    );

    return true;
  }

  const observer = new MutationObserver(function () {
    bindFix();
  });

  if (!bindFix()) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener("Pandectes_Consent_Update", function () {
    observer.disconnect();
  });
})();